module.exports = __webpack_public_path__ + "img/icon-x2_green.4fc0e4db.svg";